export const themeOptionFactory = (theme) => ({
  components: {
    MovieLoadingScreen: {
      styleOverrides: {
        container: {
          display: "flex",
          alignItems: "center",
          width: "100%",
          height: "100%",
        },
      },
    },
    MovieShowTimesPage: {
      styleOverrides: {
        root: {
          paddingTop: theme.spacing(2.5),
          display: "flex",
          justifyContent: "center",
        },
        pageCardContent: {
          padding: theme.spacing(0),
          position: "relative",
        },
        cinemasFilterContainer: {
          position: "absolute",
          left: "50%",
          zIndex: 2,
          transform: "translateX(-50%)",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          bottom: 0,
          width: "100%",
          maxWidth: "84%",
          marginBottom: theme.spacing(5),
          "&:after": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 10%, #fff 90%)",
            zIndex: 1,
            position: "absolute",
            right: "-2px",
            top: 0,
            bottom: 0,
          },
          "&:before": {
            content: "''",
            display: "inline-block",
            width: "20px",
            background:
              "linear-gradient(90deg, #fff 10%, rgba(255, 255, 255, 0.00) 90%)",
            zIndex: 1,
            position: "absolute",
            left: "-2px",
            top: 0,
            bottom: 0,
          },
        },
        gridContainer: {
          display: "grid",
          gridAutoFlow: "dense",
          gridTemplateColumns: "repeat(3, 327px)",
          gap: theme.spacing(6, 2.75),
          paddingBottom: theme.spacing(6.25), //PADDING 50 px เพื่อไม่ให้บังdataข้างล่าง
          overflowY: "auto",
          maxHeight: "818px",
          //hide scrollbar
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
        },
      },
    },
    MovieShowTimesCard: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2.5),
          boxShadow: "none",
        },
        cardMedia: {
          width: "100%",
          aspectRatio: "1/1.5",
          flexShrink: 0,
          borderRadius: theme.spacing(1.25),
          objectFit: "cover",
        },
        cardContent: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: theme.spacing(0.5),
          padding: 0,
          "&:last-child": {
            paddingBottom: 0,
          },
        },
        movieTitle: {
          fontSize: "1.5rem",
          color: theme.palette.text.primary,
          fontWeight: "700",
          lineHeight: 1.21,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden",
        },
        movieGenre: {
          fontSize: "1.25rem",
          color: theme.palette.text.secondary,
          lineHeight: 1.45,
        },
        movieDuration: {
          fontSize: "1.25rem",
          color: theme.palette.text.primary,
          lineHeight: 1.45,
        },
        infoContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(5),
        },
      },
    },
    MovieDetailPage: {
      styleOverrides: {
        pageCardContent: {
          display: "flex",
          flexDirection: "column",
          alignContent: "flex-start",
          padding: theme.spacing(5.5, 9.75, 7.5),
        },
        movieDetailContainer: {
          display: "flex",
          flexDirection: "column",
          height: "100%",
        },
        headerLayout: {
          display: "flex",
          marginBottom: theme.spacing(6.25),
        },
        bodyLayout: {
          display: "flex",
          gap: theme.spacing(5),
          overflow: "hidden",
        },
        theatreShowtimeLayout: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(4),
          position: "relative",
          width: "100%",
          overflowY: "scroll",
          "::-webkit-scrollbar": {
            display: "none",
          },
          MsOverflowStyle: "none",
          scrollbarWidth: "none",
          "&:after": {
            content: "''",
            width: "100%",
            pointerEvents: "none",
            display: "inline-block",
            position: "sticky",
            zIndex: 1,
            left: 0,
            right: 0,
            bottom: 0,
            minHeight: "140px",
            background:
              "linear-gradient(0deg, #FFF 37.46%, rgba(255, 255, 255, 0.00) 94.07%)",
          },
        },
        emptyShowtimeWrapper: {
          display: "flex",
          alignItems: "center",
          width: "100%",
          height: "100%",
        },
        posterButtonContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(4),
        },
        poster: {
          width: "350px",
          aspectRatio: "1 / 1.5",
          borderRadius: "10px",
          objectFit: "cover",
          display: "block",
        },
        button: {},
      },
    },
    MovieHeader: {
      styleOverrides: {
        root: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(4),
          flexGrow: 0,
        },
        cinemaLogo: {
          width: "123px",
          aspectRatio: "123 / 56",
          objectFit: "cover",
          display: "block",
        },
        titleTypography: {
          fontSize: "2rem",
          fontWeight: 700,
          lineHeight: 0.9,
        },
        titleContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
        },
        genreDurationContainer: {
          display: "flex",
          flexDirection: "row",
          gap: theme.spacing(7.5),
        },
        genreTypography: {
          fontSize: "1.25rem",
          fontWeight: 700,
          lineHeight: 1.45,
          color: theme.palette.text.secondary,
        },
        bodyTypography: {
          fontSize: "1.25rem",
          fontWeight: 700,
          lineHeight: 1.45,
        },
      },
    },
    MovieTheatre: {
      styleOverrides: {
        root: {
          width: "697px",
          display: "flex",
          flexDirection: "column",
          paddingBottom: theme.spacing(4),
          borderBottom: `1px solid ${theme.palette.primary.dark}`,
        },
        titleTypography: {
          fontSize: "2rem",
          fontWeight: 700,
          lineHeight: 0.9,
        },
        bodyTypography: {
          fontSize: "1.25rem",
          fontWeight: 700,
          lineHeight: 1.45,
        },
        theatreContainer: {
          display: "flex",
          gap: theme.spacing(10),
          paddingBottom: theme.spacing(5),
        },
        showTimeContainer: {
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(2),
        },
        showTimeTypography: {
          fontSize: "1.5rem",
          lineHeight: 1.2,
          "&.is-active": {
            fontSize: "1.5rem",
            fontWeight: 700,
            lineHeight: 1.2,
            color: theme.palette.primary.dark,
          },
        },
        timeSlotsContainer: {
          display: "flex",
          flexDirection: "row",
          columnGap: theme.spacing(5),
          rowGap: theme.spacing(2),
          flexWrap: "wrap",
        },
        movieDetailsWrapper: {
          display: "flex",
          gap: theme.spacing(2.5),
        },
        contentWrapper: {
          gap: theme.spacing(1),
          display: "flex",
          justifyContent: "center",
        },
      },
    },
  },
})
